import React, { useCallback, useMemo } from "react";
import DynamicLinesDialog from "../../../components/DynamicLinesDialog";
import {
    fetchDataEngine,
    graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { HRService, accountsmanagement } from "../../../config";
import { allAccountSubCategories } from "../../../data/Axios/queries";
import { normalizeExpenseTypes } from "../expenseTypeOptions";

const base_url = HRService.uri;
const accounts_url = accountsmanagement.uri;

const ManageImprestLinesDialog = ({ open, onClose, imprestData,refetchData, extraActions }) => {

    // Options loaders
    const loadExpenseTypes = useCallback(async () => {
        return normalizeExpenseTypes(
            await graphqlQuery(allAccountSubCategories, accounts_url)
        );
    }, []);

    const loadAccounts = useCallback(async (expenseTypeId) => {
        if (!expenseTypeId) return [];
        const accs = await fetchDataEngine(
            "allAccountsByColumnValues",
            "accounts",
            { accountSubcategoryId: Number(expenseTypeId) },
            ["id", "accountNumber", "accountName"],
            accounts_url
        );
        return (accs || []).map((account) => ({
            ...account,
            id: Number(account.id),
            value: Number(account.id),
            label: account.accountNumber
                ? `${account.accountName} (${account.accountNumber})`
                : account.accountName,
        }));
    }, []);

    // Form fields configuration
    const formFields = useMemo(() => [
        {
            name: "expenseTypeId",
            label: "Expense Type",
            type: "select",
        },
        {
            name: "accountId",
            label: "Account",
            type: "dependent-select",
            dependsOn: "expenseTypeId",
        },
        {
            name: "amountRequested",
            label: "Amount Requested",
            type: "number",
        },
        {
            name: "description",
            label: "Description",
            type: "text",
        },
    ], []);

    // Table columns configuration
    const columns = useMemo(() => [
        { field: "id", headerName: "ID", flex: 0.4 },
        { field: "description", headerName: "Description", flex: 2 },
        { field: "amountRequested", headerName: "Amount", flex: 1, format: "currency" },
    ], []);

    // Query configuration
    const queryConfig = useMemo(() => ({
        name: "imprestApplicationLinesByImprestId",
        modelName: "imprestApplicationLines",
        inputField: "imprestId",
        fields: ["id", "expenseTypeId", "accountId", "description", "amountRequested"],
    }), []);

    // Mutation configuration
    const mutationConfig = useMemo(() => ({
        create: "createImprestLine",
        update: "updateImprestLine",
        modelName: "imprestLine",
    }), []);

    // Options loaders map
    const optionsLoaders = useMemo(() => ({
        expenseTypeId: loadExpenseTypes,
        accountId: loadAccounts,
    }), [loadAccounts, loadExpenseTypes]);

    return (
        <DynamicLinesDialog
            open={open}
            onClose={onClose}
            title="Manage Imprest Lines"
            parentData={imprestData}
            parentIdField="imprestId"
            baseUrl={base_url}
            queryConfig={queryConfig}
            mutationConfig={mutationConfig}
            refetchData={refetchData}
            formFields={formFields}
            columns={columns}
            optionsLoaders={optionsLoaders}
            additionalMutationData={{ isActive: 1 }}
            headerActions={extraActions}
        />
    );
};

export default ManageImprestLinesDialog;
